import {
  WIZARD_BUILD_STEPS,
  type WizardBuildStep,
} from "@/lib/mentor-profile/profile-sections";

export {
  PROFILE_SECTIONS,
  REVIEW_SECTIONS,
  SECTION_BY_ID,
  SECTION_BY_REVIEW,
  SECTION_TO_BUILD_STEP,
  WIZARD_BUILD_STEPS,
  isReviewSection,
  sectionSummary,
  sectionValue,
  type ReviewSection,
  type SectionSummary,
  type WizardBuildStep,
} from "@/lib/mentor-profile/profile-sections";

export const WIZARD_PHASES = [
  "confirm",
  "intro",
  "revision_feedback",
  "build",
  "review",
  "submitted",
  "approved",
] as const;

export type OnboardingPhase = (typeof WIZARD_PHASES)[number];

export type WizardFurthestStep =
  | "confirm"
  | "intro"
  | WizardBuildStep
  | "review";

export function buildStepIndexFromFurthest(
  furthestStep: string | null | undefined,
): number {
  if (!furthestStep) return 0;
  const index = WIZARD_BUILD_STEPS.indexOf(furthestStep as WizardBuildStep);
  if (index >= 0) return index;
  if (furthestStep === "review" || furthestStep === "submitted") {
    return WIZARD_BUILD_STEPS.length - 1;
  }
  return 0;
}

export function maxFurthestStep(
  current: string | null | undefined,
  next: WizardFurthestStep,
): WizardFurthestStep {
  const order: WizardFurthestStep[] = [
    "confirm",
    "intro",
    ...WIZARD_BUILD_STEPS,
    "review",
  ];
  const currentIndex = current
    ? order.indexOf(current as WizardFurthestStep)
    : -1;
  const nextIndex = order.indexOf(next);
  if (nextIndex < 0) return (current as WizardFurthestStep) || "confirm";
  if (currentIndex < 0) return next;
  return order[Math.max(currentIndex, nextIndex)]!;
}
